var t = /* @__PURE__ */ ((r) => (r.Overlay = "overlay", r.Push = "push", r))(t || {});
const a = ["overlay", "push"];
var s = /* @__PURE__ */ ((r) => (r.Right = "right", r.Left = "left", r))(s || {});
const g = ["right", "left"];
var O = /* @__PURE__ */ ((r) => (r.Sm = "sm", r.Md = "md", r.Lg = "lg", r))(O || {});
const h = ["sm", "md", "lg"];
export {
  a as SLIDEOUT_MODES,
  g as SLIDEOUT_POSITIONS,
  h as SLIDEOUT_SIZES,
  t as SlideoutMode,
  s as SlideoutPosition,
  O as SlideoutSize
};
